import { gql } from "@apollo/client";

const GET_CURRENT_PROGRESS = gql`
  query CurrentProgress($levelId: ID!) {
    currentProgress(levelId: $levelId) {
      level
      totals
      studied
      reviewed
      reviewedSeveral
      skipped
    }
  }
`;

export default GET_CURRENT_PROGRESS;
